<template>
	<div class="innerhd">
		<div class="topBar">
			<div class="wrapper">
				<div class="flSpan">
					<span>Hi，欢迎您来到翰林征信！   </span>
					<span>服务热线：<strong>400-800-000</strong></span>
				</div>
				<div class="frnav">
					<ul>
						<li @mouseover="mouseOver(index)" v-for="(item,index) in topList"
						:key="index" v-if="isLogin && item.name != '免费注册' && item.name != '登录'">
							<router-link :to="{path:item.path}">
								{{item.name}}
							</router-link>
							<span class="line"></span>
							<ul v-if="item.show" @mouseleave="mouseLeave(index)">
								<li v-for="item1 in item.children" :key="item1.index">
									<router-link :to="{path:item1.path}">
										{{item1.name}}
									</router-link>
								</li>
							</ul>
						</li>
						<li @mouseover="mouseOver(index)" v-for="(item,index) in topList" :key="index" v-if="!isLogin">
							<router-link :to="{path:item.path}">
								{{item.name}}
							</router-link>
							<span class="line"></span>
							<ul v-if="item.show" @mouseleave="mouseLeave(index)">
								<li v-for="item1 in item.children" :key="item1.index">
									<router-link :to="{path:item1.path}">
										{{item1.name}}
									</router-link>
								</li>
							</ul>
						</li>
						<li style="color:#fff" v-if="isLogin">
							欢迎您: <span >【{{username}}】</span>
						</li>
						<li v-if="isLogin" @click="exitLogin">
						<!-- <router-link :to="{path:'/Login'}"> -->
						<img class="img" :src="mIcon5"/>  <span style="color:#fff">    退出登录 </span>
						<!-- </router-link> -->
						<span class="line"></span>
					</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="wrapper paddTop clearfix">
			<div class="logo">
				<a href="#"><img @click="checkIndex" :src="logo" /></a>
			</div>
			<div class="hdSearch" v-show="show">
				<img  class="icon" :src="searchB" />
				<input class="inpt" v-model="name" type="text" placeholder="请输入搜索名称" />
				<button class="btn"  @click="selectByname">全站搜索</button>
			</div>
		</div>
	</div>
</template>

<script>
import logo from '@/assets/img/logo.png'
import searchB from '@/assets/img/search_b.png'
import mIcon5 from '@/assets/img/m_icon5.png'
export default {
  name: 'innerhd',
  props: {
    show: Boolean
  },
  components: {
  },
  data () {
    return {
      logo,
      name: '',
	  searchB,
	  mIcon5,
	  username: ''
    }
  },
  computed:{
	isLogin(){
		if (!localStorage.getItem('token')) {
			return false;
		} else {
			this.username = localStorage.getItem('name')
			return true;
		}
	},
	topList(){
	  let list = this.$store.state.navList;
	  if(list.length > 0){
		list = list.filter(item => item.name == '头部导航');
		list = list[0].children.filter(item => item.showTop == '1');
	  }
	  return list;
	}
  },
  created () {
     this.showInput()
  },
  methods: {
	checkIndex() {
		this.$router.push({path:'/'})
	},
	showInput() {
		this.name = this.$parent.childName
	},
    // 移入
    mouseOver(index) {
		this.topList[index].show=true
    },
    // 移出
    mouseLeave(index) {
		this.topList[index].show=false
    },
   exitLogin () { // 退出登录删除token和name
	  this.$confirm('确定注销并退出系统吗？', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning'
		}).then(() => {
		localStorage.removeItem('name')
		localStorage.removeItem('token')
		this.$router.push({ path:"/Login" })
	}).catch(() => {});
    },
    selectByname () {
      this.$parent.selectMemberInfo()
      this.$emit('update:show', true)
	}
  }
}
</script>

<style scoped lang="scss">
	.innerhd {
		background: #fff;
	}
	.topBar {
		height: 36px;
		line-height: 36px;
		background: #2a323f;
		overflow: hidden;
		.flSpan {
			float: left;
			font-size: 14px;
			color: #999896;
			strong {
				color: #fff;
				font-weight: bold;
			}
		}
		.frnav {
			float: right;
			li {
				display: inline-block;
				*display: inline;
				zoom: 1;
				margin-left: 34px;
				cursor:pointer;
				font-size: 14px;
					color: #fff;
				a {
					font-size: 14px;
					color: #fff;
				}
				.regs {
					color: #1e90ff;
				}
				.login {
					color: #ffb05d;
				}
			}
		}
	}

	.innerhd {
		.paddTop {
			height: 120px;
		}
		.logo {
			float: left;
			padding-left: 10px;
			padding-top: 30px;
			img {
				width:224px;
			}
		}
		.hdSearch {
			float: right;
			position: relative;
			padding-top: 32px;
			.inpt {
				width: 414px;
				height: 42px;
				font-size: 16px;
				color: #000;
				margin-right: 20px;
				border: 1px solid #d9d9d9;
				outline: 0;
				text-indent: 50px;
			}
			img {
				position: absolute;
				top: 46px;
				left: 16px;
			}
			.btn {
				width: 110px;
				height: 44px;
				font-size: 18px;
				color: #fff;
				border-radius: 4px;
				background: #308ff0;
				border: none;
				outline: 0;
				cursor: pointer;
			}
		}
	}
	/*.innerhdon{position:fixed;top:0;left:0;width:100%;z-index:20;box-shadow:0 0 10px 0 rgba(0,0,0,0.1);}*/
</style>
